<ng-container *ngIf="ready">
  <div
    id="toolContent"
    [ngClass]="{
      tc: isLastPage$ | async,
      firstPage: isFirstPage$ | async,
      lastPage: isLastPage$ | async,
      hasPageHeader: hasPageHeader
    }"
  >
    <app-page-header
      *ngIf="header && (isModal$ | async) === false"
      [header]="header"
    ></app-page-header>
    <app-page-hero
      *ngIf="hero && (isModal$ | async) === false"
      [hero]="hero"
    ></app-page-hero>
    <ng-container *ngIf="cards && cards.length && (isModal$ | async) === false">
      <app-page-card *ngFor="let card of cards" [card]="card"></app-page-card>
    </ng-container>
    <app-page-calltoaction
      *ngIf="
        callToAction &&
        (isForm$ | async) === false &&
        (isModal$ | async) === false
      "
      [item]="callToAction"
    ></app-page-calltoaction>

    <ng-container *ngIf="modal && (isModal$ | async)">
      <app-page-modal [modal]="modal"></app-page-modal>
    </ng-container>

    <app-page-navigation
      [direction$]="dir$"
      [isForm$]="isForm$"
      [isModal$]="isModal$"
      [isFirstPage$]="isFirstPage$"
      [isLastPage$]="isLastPage$"
      (nextEvent)="next()"
      (previousEvent)="previous()"
    ></app-page-navigation>

    <ng-container
      *ngIf="(isModal$ | async) === false && (isModal$ | async) === false"
    >
      <footer id="toolFooter">
        <span
          ><a href="https://godtoolsapp.com" target="_blank"
            >Learn more at godtoolsapp.com</a
          ></span
        >
        <span
          >© 1994-{{ currentYear }}
          <a href="https://cru.org" target="_blank">Cru</a>. All Rights
          Reserved.</span
        >
      </footer>
    </ng-container>
  </div>
</ng-container>
